import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import styles from './styles.pcss';
import type { AccumulateProps } from './types';

const cn = classNames.bind(styles);

export const Accumulate: FC<AccumulateProps> = ({ isUnlimited, isLow, rest, size }) => (
  <div className={cn('component')}>
    {isUnlimited ?
      <Text size="size4-m">∞</Text>
    : <>
        <Text color={isLow ? 'scarlet' : 'grey95'} size="size4-m">
          {rest}
        </Text>
        {size && (
          <>
            <Text color="grey60" size="size5-r-s">
              /
            </Text>
            <Text color="grey60" size="size5-r-s">
              {size}
            </Text>
          </>
        )}
      </>
    }
  </div>
);
